export default __webpack_public_path__ + "summarybd9fd7.png";